import { gql } from '@apollo/client';
import { ErrorMessageInfo } from '@retainerclub/shared-api';
import { TaxProfileTemplateInfo } from '../fragments';

export default gql`
  mutation CreateTaxProfileTemplate($input: TaxProfileTemplateCreateInput!) {
    createTaxProfileTemplate(input: $input) {
      clientMutationId
      errorMessages {
        ...ErrorMessageInfo
      }
      taxProfileTemplate {
        ...TaxProfileTemplateInfo
      }
    }
  }
  ${ErrorMessageInfo}
  ${TaxProfileTemplateInfo}
`;
